"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.u0034 = void 0;
var u0034 = {
  "viewBox": "0 0 2600 2760.837",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2029 1984h-292v449h-241v-449H571v-218l908-1347h258v1337h292v228zm-533-228v-488q0-87 3.5-230t9.5-245l5-116h-13q-18 55-55.5 128.5T1378 923l-563 833h681z"
    },
    "children": []
  }]
};
exports.u0034 = u0034;